import Chart from 'chart.js';
import GenericGraphic from './GenericGraphic.js';
import { formatPercentAndMoney, formatTooltipCommon } from '../../functions/formatGraphic.js';
/**
 * Class para criação de Cráfico do tipo de ByType
 */
class ByType extends GenericGraphic {

  constructor(element, data) {
    super(data);
    this.element = element;
  }

  /**
   * Método de criação de gráficos,
   * seguindo a estrutura do Chartjs,
   * incluindo as opçõe que podem ser atribuídas
   *
   * @return {Charjs} Instância de Chartjs do tipo Pie
   */
  createChart() {
    return new Chart(this.element, {
      type: 'pie',
      data: {
        datasets: [{
          data: this.dataSet,
          backgroundColor: this.colors(),
          label: 'Dataset 1'
        }],
        labels: this.labels
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              const percent = formatPercentAndMoney(tooltipItem, data);
              return formatTooltipCommon(tooltipItem, data) + ' - ' + percent;
            }
          }
        },
      }
    });
  }
}
export default ByType;
